import React from 'react';

const Portfolio = () => {
  const badges = [
    {
      id: "aws-ml",
      title: "AWS Certified Machine Learning - Specialty",
      url: "https://www.credly.com/badges/8f4ae7ec-6cda-47b3-b5c3-9cbe13321187"
    },
    {
      id: "ai-gov",
      title: "IAPP AI Governance Professional",
      url: "https://www.credential.net/8f1ed07d-d0b2-400a-8469-efa21f9c40ec#acc.C5fjH3MV"
    },
    {
      id: "dsoc",
      title: "Drone Security Operations Certificate (DSOC)",
      url: "https://www.credly.com/badges/be54e1b8-9b7f-411c-82fe-6ecb3e17cc93"
    },
    {
      id: "ai-sec",
      title: "Foundations of AI Security",
      url: "https://www.credly.com/badges/f7e9b7ba-b3d3-425c-a5c1-36ee5c067e67"
    }
  ];

  return (
    <div className="min-h-screen bg-[#1a237e] p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        {/* Main Content */}
        <main className="space-y-4">
          {/* Header Card */}
          <div className="bg-white rounded-lg p-6 shadow">
            <h1 className="text-3xl font-bold text-center mb-6">
              BEN.LEARNS_
            </h1>
            
            {/* Social Links */}
            <div className="flex justify-center space-x-8 mb-6">
              <a href="https://www.linkedin.com/in/benkereopayorke/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-800 hover:text-blue-600 transition-colors">
                LinkedIn
              </a>
              <a href="https://github.com/Benjamin-KY"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-800 hover:text-blue-600 transition-colors">
                GitHub
              </a>
              <a href="https://scholar.google.com/citations?user=mhFLaqgAAAAJ&hl"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-800 hover:text-blue-600 transition-colors">
                Google Scholar
              </a>
            </div>

            {/* Titles */}
            <div className="text-gray-800 text-center divide-y divide-gray-200">
              <p className="py-2">Senior Security Specialist 🛡️ AI Security Researcher</p>
              <p className="py-2">Associate Editor of IEEE Transactions on Technology and Society</p>
              <p className="py-2">Member of the Professional Standards Board of the Australian Computer Society</p>
              <p className="py-2">Member of the AISA QLD Committee</p>
            </div>
          </div>

          {/* About */}
          <div className="bg-white rounded-lg p-6 shadow">
            <h2 className="text-xl font-semibold mb-4">About</h2>
            <p className="text-gray-800">
              Ben Kereopa-Yorke is fascinated by the beautiful complexity that emerges when artificial intelligence meets security. As a Senior Security Specialist, co-manager of Telstra's ISMS and an AI and security teacher, mentor, and researcher, he approaches complex security challenges with the same curiosity that drives particle physicists to smash atoms - breaking big problems into understandable pieces and rebuilding them into elegant solutions.
            </p>
          </div>

          {/* Research & Achievements */}
          <div className="bg-white rounded-lg p-6 shadow">
            <h2 className="text-xl font-semibold mb-4">Research & Achievements</h2>
            <p className="text-gray-800">
              A 2024 AISA Researcher of the Year finalist and core team member of the OWASP Machine Learning Security Top 10, Ben splits his time between developing practical security frameworks and pushing the boundaries of AI security research as an Associate Editor of IEEE Transactions on Technology and Society. His recent work on AI-enhanced cybersecurity for SMEs and the ClausewitzGPT framework demonstrates his knack for making complex concepts surprisingly simple (and simple concepts surprisingly complex).
            </p>
          </div>

          {/* Certification Badges */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {badges.map((badge) => (
              <a
                key={badge.id}
                href={badge.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white p-4 rounded-lg shadow text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-10 h-10 bg-blue-500 rounded-full mx-auto mb-2 flex items-center justify-center text-white">
                  🏅
                </div>
                <span className="text-sm font-medium text-gray-800">{badge.title}</span>
              </a>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Portfolio;